/** @typedef {import('../ImageOverlayView').ImageOverlayView} ImageOverlayView */

/**
 * Sets whether this graphic can be clicked.
 * @param {boolean} clickable If `true`, this overlay will be clickable on the map; otherwise it will not.
 * @param {ImageOverlayView} overlayView The graphic to set clickable
 */
function setClickable(clickable, overlayView) {
  overlayView.clickDiv.style['pointer-events'] = clickable ? 'auto' : 'none';
}

export {setClickable};
